import styled from 'styled-components';

import Typography from '@klv/atoms/typography';

export const ContentWrapper = styled.div`
  grid-column: 1 / -1;

  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      grid-column: 1 / -2;
    }

    ${theme.screenSize.s1366.mediaQuery} {
      grid-column: 1 / -1;
    }
  `}
`;

export const StyledFooterCta = styled.aside`
  ${({ theme }) => `
    background: ${theme.footerCta.backgroundColor};
    color: ${theme.footerCta.textColor};
    padding: 3.6rem 0 5rem;
    width: 100%;
    ${theme.globalPadding};
  `}
`;

export const StyledHeadline = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.footerCta.textColor};
    margin: 0 0 4.8rem;
  `}
`;
